import { asset } from "@/lib/asset";
import DOMPurify from "dompurify";
import { useState } from "react";
import { Tabs } from "./Tabs";
import { SlideTemplate } from "./SlideTemplate";

const departments = [
  {
    id: "it",
    title: "IT",
    tabs: [
      {
        id: "it_sys_inventory",
        title: "Сквозной мониторинг",
        type: "slide",
        slides: [
          {
            id: "it_sys_inventory-01",
            text: "Карта топологии захватывает и визуализирует среду приложения. Сюда входит вертикальный стек: инфраструктура, службы и процессы. Горизонтальный стек: связи входящих и исходящих вызовов. Обнаружение новых компонентов среды и обновлений происходит автоматически.",
          },
          {
            id: "it_sys_inventory-02",
            text: "Карта Service Flow – это автоматическое построение сквозных цепочек операций. Это позволяет по транзакциям контролировать как работает приложение, какие у него есть взаимосвязи и определить первопричину проблемы.",
          },
          {
            id: "it_sys_inventory-03",
            text: "Автоматически отслеживайте всю инфраструктуру, включая гибридную среду, контейнеры, виртуальные машины, сеть, серверы, хранилище и многое другое.",
          },
          {
            id: "it_sys_inventory-04",
            text: "Автоматически отслеживайте всю инфраструктуру, включая гибридную среду, контейнеры, виртуальные машины, сеть, серверы, хранилище и многое другое.",
          },
        ],
      },
      {
        id: "end_to_end_query",
        title: "Сквозная трассировка",
        text: 'Просмотр каждой операции на уровне кода. С "Ключ-Астром" вы находите ошибки моментально и ставите SLA для каждой структуры. Теперь все причины и ответственные видны в режиме реального времени.',
      },
      {
        id: "user_action_analysis",
        title: "Путь пользователя",
        text: "Отслеживание действий пользователей в режиме реального времени: вы можете видеть состояние устройства, а также запросы и ошибки бэкенда прямо в процессе выполнения транзакции.",
      },
      {
        id: "log_file_events_mon",
        title: "Мониторинг логов",
        text: "Исследуйте и решайте проблемы быстрее с помощью ИИ-анализа журналов в контексте.",
      },
      {
        id: "release_testing",
        title: "Тест релизов",
        text: "Процесс тестирования существенно ускоряется. Вы видите систему изнутри – все до малейших деталей –  быстро правите ошибки – быстрее выпускаете новые версии ПО.",
      },
      {
        id: "synthetic_monitoring",
        title: "Синтетический мониторинг",
        text: "Благодаря синтетическому мониторингу вы поймете соответствует ли ваше приложение требованиям SLA: быстро найдете неполадки с помощью ИИ. Ранжируете исправления в порядке важности для бизнеса.",
      },
    ],
  },
  {
    id: "biz",
    title: "Бизнес",
    tabs: [
      {
        id: "biz_open_reduction",
        title: "Мониторинг бизнес-процессов",
        text: "Демонстрация длительности каждой операции и всего бизнес-процесса на базе анализа программного кода. Помогает понять как оптимизировать и автоматизировать процессы, чтобы сократить расходы.",
      },
      {
        id: "biz_analysis_it",
        title: "Анализ влияние IT-проблем на бизнес",
        text: "Сделайте IT процессы прозрачными для бизнеса. Отношения между IT и бизнес-подразделениями будут строится на метриках и показателях, а не на поиске виноватых.",
      },
      {
        id: "biz_red_testing",
        title: "Выпуск ПО",
        text: "Контролируйте вложения в создание новых IT-продуктов и сервисов. Данные о состоянии IT и уже работающих бизнес-приложений позволяет рассчитать эффект от внедрения сервиса/релиза. ",
      },
      {
        id: "biz_impr_call",
        title: "Сокращение звонков",
      },
    ],
  },
  {
    id: "mar",
    title: "Маркетинг",
    tabs: [
      {
        id: "mar_user_actions",
        title: "Действия пользователя",
        text: "Связывайте технические и маркетинг показатели. Теперь на одном экране с маркетинг аналитикой вы получаете и аналитику по техническим показателям: например, как отразились на клиентах увеличение времени загрузки компонентов сервиса. ",
      },
      {
        id: "mar_real_user_mon",
        title: "Мониторинг цифрового опыта",
        text: '"Ключ-Астром" — единственный поставщик, который обеспечивает полное представление о клиентском опыте при каждой цифровой транзакции. Платформа дает вам полную картину действий пользователей от интерфейса до сервера.',
      },
      {
        id: "mar_analysis_biz",
        title: "Анализ продукта",
        text: "На дашбордах можно выводить ключевые бизнес показатели для аналитиков и менеджеров продукта. <br> CR (Churn rate - Уровень оттока), ARPU (average revenue per user - Выручка с одного пользователя), ARPPU (average revenue per paying user - Выручка с одного платящего пользователя), LTV (life-time value - Пожизненная ценность пользователя).",
      },
    ],
  },
];

export const SlidesUniqueKA = () => {
  const [activeDept, setActiveDept] = useState("it");

  return (
    <section className="bg-white">
      <div className="container-fluid">
        <div className="text-center px-0 mb-[40px]">
          <div className="text-center bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text text-[20px] leading-normal lg:text-[32px] lg:leading-[44.8px] font-bold font-['Open Sans']">
            Особенности «Ключ-Астром»
          </div>
        </div>

        <div className="flex justify-center items-center">
          <ul className="grid grid-cols-2 lg:grid-cols-3 w-full my-[40px] gap-3 lg:gap-4 justify-items-center max-w-full px-[3px]">
            {departments.map((dept, index) => (
              <li
                key={dept.id}
                className={`w-full text-center ${
                  index === departments.length - 1 &&
                  departments.length % 2 === 1
                    ? "col-span-2 lg:col-span-1"
                    : ""
                }`}
              >
                <button
                  className={`w-full h-[179px] md:h-[244px] lg:h-[44px] text-white text-[20px] lg:text-xl py-[5px] font-bold font-['Open Sans'] text-center border-2 transition-all
                      ${
                        activeDept === dept.id
                          ? "bg-[#FFD574] border-[#FFD574] text-black shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]"
                          : "bg-[#C0834D] border-[#C0834D] text-white"
                      }
                      ${
                        index === 0
                          ? "rounded-tl-[40px] md:rounded-tl-[60px]"
                          : index === 1
                            ? "rounded-tr-[40px] md:rounded-tr-[60px]"
                            : "rounded-b-[40px] md:rounded-b-[60px]"
                      }
                      lg:rounded-[20px]`}
                  onClick={() => setActiveDept(dept.id)}
                >
                  {dept.title}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="my-[40px] w-full">
          {departments.map(
            (dept) =>
              activeDept === dept.id && (
                <div className="w-full" key={dept.id}>
                  <div className="text-center bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text text-base leading-normal xl:text-[32px] xl:leading-[44.8px] font-bold font-['Open Sans'] my-[40px] xl:mb-[46px]">
                    {dept.title}
                  </div>
                  <Tabs
                    key={dept.id}
                    tabs={dept.tabs.map((tab) => ({
                      ...tab,
                      content:
                        tab.type === "slide" ? (
                          <SlideTemplate
                            slideId={tab.id}
                            imgDir="apmkit"
                            slides={tab.slides}
                          />
                        ) : (
                          <div className="text-center xl:mt-[25px]">
                            <img
                              src={asset(`/img/apmkit/${tab.id}.png`)}
                              className="w-full max-w-full xl:w-[695px] rounded-[20px] mx-auto"
                            />
                            {tab.text && (
                              <div className="mt-4 max-w-full xl:w-[880px] mx-auto mb-3">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(tab.text),
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        ),
                    }))}
                    defaultActive={dept.tabs[0].id}
                  />
                </div>
              ),
          )}
        </div>

        <div className="mt-[60px] xl:mt-[80px] flex flex-col items-center text-center gap-[24px]">
          <div className="bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text text-[20px] leading-normal lg:text-[32px] lg:leading-[44.8px] font-bold font-['Open Sans']">
            Безопасность
          </div>
          <p className="max-w-full xl:w-[880px] text-[#544A28] text-[16px] xl:text-[18px] leading-normal font-['Open Sans']">
            Модуль информационной безопасности помогает выявлять уязвимости и
            сокращает время их устранения до 12 раз. Снижает риски для бизнеса и
            ускоряет выпуск обновлений ПО.
          </p>
          <a
            href="/mib"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#FFD574] text-black font-bold font-['Open Sans'] text-[18px] px-[40px] py-[12px] rounded-[20px] border-2 border-[#FFD574] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] transition-all hover:bg-[#C0834D] hover:border-[#C0834D] hover:text-white"
          >
            Подробнее
          </a>
        </div>
      </div>
    </section>
  );
};

export default SlidesUniqueKA;
